export const PHOTOS_LIST = ["BANNER_IMAGES","HIGHLIGHTS", "NCC_HIGHLIGHTS","NSS_HIGHLIGHTS","FACILITY_HIGHLIGHTS","RESEARCH_HIGHLIGHTS"]

export const PHOTOS_LIST_NEW = [
    {
        title: "Banner Images",
        value: "BANNER_IMAGES"
    },
    {
        title: "Past Recruiters",
        value: "PAST_RECRUITERS"
    },
    
    // {
    //     title: "Facilities",
    //     value: "FACILITY_HIGHLIGHTS"
    // }
]